export default __webpack_public_path__ + "static/media/crash.196a1f65.svg";